import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-p-1 ns-color-black ${className}`}
            onClick={() => filter.remove()}
        >
            ×
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-selected-filters">
                {/* <div class="ns-col-10 ns-d-flex ns-flex-wrap ns-align-items-center"> */}
                    {filters.map(filter => (
                        <div class="ns-selected-filter ns-d-flex ns-align-items-center">
                            <span>{filter.value}</span>
                            <FilterRemoveButton filter={filter} />
                        </div>
                    ))}
                {/* </div> */}
            </div>
        )
    )
}
